import { render, staticRenderFns } from "./EmployeeAccessControlSettings.vue?vue&type=template&id=93022036&scoped=true"
import script from "./EmployeeAccessControlSettings.vue?vue&type=script&lang=js"
export * from "./EmployeeAccessControlSettings.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAccessControlSettings.vue?vue&type=style&index=0&id=93022036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93022036",
  null
  
)

export default component.exports